import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '../../services/translate';

import { AlertType } from './alert-type';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertComponent {
  @Input() type: AlertType | `${AlertType}` = AlertType.Info;
  @Input() closable = true;
  @Input() smallAlert = false;
  @Input() suppressAnnouncement = false;

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<void>();

  private boundKeyDownFunc = this.onKeyDown.bind(this);

  typeDict: { [key: string]: string } = {
    'alert-info': 'Important',
    'alert-success': 'Success',
    'alert-warning': 'Warning',
    'alert-error': 'Error',
  };

  constructor(private translateService: TranslateService) {}

  alertClose() {
    window.removeEventListener('keydown', this.boundKeyDownFunc);
    this.close.emit();
  }

  onFocus() {
    window.addEventListener('keydown', this.boundKeyDownFunc);
  }

  onBlur() {
    window.removeEventListener('keydown', this.boundKeyDownFunc);
  }

  getAriaRole() {
    if (this.typeDict[this.type] === 'Error') {
      return 'alert';
    } else {
      return 'alert-dialog';
    }
  }

  getAlertType(type: string) {
    return this.translateService.translate('ngx-shared-' + this.typeDict[type].toLowerCase());
  }

  getIsClosable() {
    return this.type === AlertType.Error ? false : this.closable;
  }

  private onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.alertClose();
    }
  }
}
